import { getSortedPosts } from '$lib/posts';
import type { Load } from '@sveltejs/kit';

export const load: Load = () => {
	return {
		posts: getSortedPosts()
	};
};
